import groq from 'groq'

export const getActivityGroq = groq`
    *[_type == "juniorDrill" && language == $language && key == $room && !(_id in path("drafts.**"))][0] {
        _id,
        elevator,
        elevatorKey,
        key,
        language,
        name,
        roomColor,
        "chest": chests[(@->key == $chest)][0]->{
            name,
            key,
            reference,
            references,
            id,
            "tabCount": count(tabs),
            "tabsActivity": tabs[]->{
                "id": serial,
                "activityCount": count(activities)
              },
            "tab": tabs[(@->serial == $tab)][0]->{
                name,
                metaDescription,
                "activityCount": count(activities),
                "activity": activities[serial == $activityNumber][0]{
                    columnLayout,
                    question,
                    alternatives,
                    shouldShuffle
            }
        }
        }
    }{
        _id,
        "metadata":{
        "language": $language,
        "chest": $chest,
        "globalId": chest.id,
        "tab": $tab,
        "elevator": $elevator,
        "room": $room,
        "tabsActivity": chest.tabsActivity,
        "metaDescription": chest.tab.metaDescription,
        "activityNumber": $activityNumber,
        "roomColor": roomColor,
        "numberOfTabs": chest.tabCount,
        "numberOfActivities": chest.tab.activityCount,
        "reference": chest.reference,
        "references": chest.references,
        "title": chest.name,
        "columnLayout": chest.tab.activity.columnLayout
        },
        "question": chest.tab.activity.question,
        "alternatives": chest.tab.activity.alternatives,
        "shouldShuffle": chest.tab.activity.shouldShuffle,
    }
`

export const getAllActivityGroq = groq`
    *[_type == "juniorDrill" && language == $language && !(_id in path("drafts.**"))][] {
    key,
    elevatorKey,
    "chests": chests[]->{
        key,
        "tabs": tabs[]->{
            serial,
            "activities": activities[]{
          serial
              }[].serial
          }
      }
  }
`

export const getAllChestIds = groq`
    *[_type == "juniorDrill" && language == $language && !(_id in path("drafts.**"))]{
          "roomKey":key,
          "elevatorKey": elevatorKey,
          "chests": chests[]-> | order(serial asc)
    }
`

export const getSiteMapChestData = groq`*[_type == 'juniorDrill' && language == $language && !(_id in path("drafts.**"))]
   {
    key,
    name,
    elevator,
    elevatorKey,
    "chests": chests[(@->state != "coming")]-> | order(serial asc) {
      name,
      key,
      serial,
      "tabs": tabs[]-> {
        name,
        serial,
        activities[]{ serial }
      }
    }
  }`
